<template>
  <div>
    <Titles />
    <div class="formBox">
      <advertisement />

      <div class="banner">
        <img src="https://www.lljrtj.com/images/logo.png" alt="" srcset="" />
        <p>醴陵市金融纠纷调解中心</p>
      </div>
      <van-form>
        <van-field
          v-model="id"
          label="身份证号:"
          name="asyncValidator"
          :rules="[{ required: true, message: '请填写身份证号' }]"
        />
        <van-field
          v-model="telephone"
          name="telephone"
          label="电话号码:"
          :rules="[{ required: true, message: '请填写电话号码' }]"
        />
        <van-field
          v-model="sms"
          center
          name="sms"
          label="短信验证码"
          :rules="[{ required: true, message: '请填短信验证码' }]"
        >
          <template slot="button">
            <van-button
              size="small"
              @click="getsms()"
              type="primary"
              :disabled="!canSendSms"
              >发送验证码</van-button
            >
          </template>
        </van-field>
        <div style="margin: 16px;">
          <van-button
            round
            block
            type="info"
            @click.native="onSubmit"
            class="btn"
            >京东金融纠纷案件查询</van-button
          >
        </div>
        <div style="margin: 16px;">
          <van-button
            round
            block
            type="info"
            @click.native="onSubmit2"
            class="btn"
            >其他金融纠纷案件查询</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>
<script>
import Titles from "../components/title.vue";
import { Toast } from "vant";

import axios from "axios";
export default {
  components: {
    Titles
  },
  data() {
    return {
      id: "",
      telephone: "",
      sms: "",
      IDmessage: "您输入的身份证无相关调解案件"
    };
  },
  methods: {
    async onSubmit() {
      let res = await axios.post("/api/case_search/search", {
        id_number: this.id,
        mobile: this.telephone,
        code: this.sms
      });
      if (res.data.code == -1) {
        Toast.fail(res.data.message);
      } else {
        this.$router.push({
          name: "inquire",
          params: { id: this.id, telephone: this.telephone, sms: this.sms }
        });
      }
    },
    async onSubmit2() {
      let res = await axios.post("/api/case_search/search2", {
        id_number: this.id,
        mobile: this.telephone,
        code: this.sms
      });
      if (res.data.code == -1) {
        Toast.fail(res.data.message);
      } else {
        this.$router.push({
          name: "inquire2",
          params: { id: this.id, telephone: this.telephone, sms: this.sms }
        });
      }
    },
    async verify() {
      let res = await axios.post("/api/apply/check", {
        id_number: this.id
      });
    },
    // 异步校验函数返回 Promise
    asyncValidator(val) {
      // return new Promise((resolve) => {
      //     Toast.loading('验证中...');
      //     axios.post('/api/apply/check', {
      //         id_number: this.id
      //     }).then(res => {
      //         Toast.clear();
      //         if (res.data.code == -1) {
      //             this.IDmessage = res.data.message
      //             resolve(false)
      //         } else {
      //             resolve(true)
      //             this.disabledsms = false
      //         }
      //     })
      // });
    },

    async getsms() {
      let res = await axios.post("/api/apply/tenxun", {
        mobile: this.telephone
      });
      if (res.data.code == 1) {
        Toast.success("短信发送成功");
      } else {
        Toast.fail(res.data.result.errmsg);
      }
    },

    isValidPhone(phone) {
      // 简单验证中国手机号
      return /^1[3-9]\d{9}$/.test(phone);
    }
  },

  computed: {
    canSendSms() {
      return (
        this.id.trim() !== "" &&
        this.telephone.trim() !== "" &&
        this.isValidPhone(this.telephone)
      );
    }
  }
};
</script>
<style scoped>
.formBox {
  padding: 3rem 0 0 0;
}

.banner {
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.banner > img {
  margin-top: 1rem;
  width: 9rem;
  height: 8rem;
  /* 对图片进行剪切，保留原始比例：*/
  object-fit: cover;
}

.banner > p {
  font-size: 1.2rem;
  font-weight: bold;
  margin: 1rem 0;
  color: #000000;
}

.btn {
  font-weight: 700;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/page/CaseInquiry.vue